import {
  LeaderIcon,
  ErrorFilledIcon,
  Title,
  CaptionLink
} from '@kvdbil/components';
import React from 'react';
import styled from 'styled-components';
import dayjs from '~/App/shared/date';
import { useTranslation } from '~/Locale';

const Container = styled.div<{ isLeading?: boolean }>`
  color: ${({ isLeading, theme }) =>
    isLeading ? theme.colors.primary.mainAlt : theme.colors.text.dark};
  text-align: center;

  svg {
    margin-right: 0.5rem;
    font-size: 1.2rem;
    color: ${({ isLeading, theme }) =>
      isLeading
        ? theme.colors.primary.mainAlt
        : theme.colors.grayscaleToned.dark3};
    margin-top: 0px;
  }
`;

export interface BiddingHeaderProps {
  isClosed: boolean;
  isLeading: boolean;
  isCounting: boolean;
  isParticipating: boolean;
  preliminaryCloseAt: string;
}
export const BiddingHeader = ({
  isClosed,
  isLeading,
  isCounting,
  isParticipating,
  preliminaryCloseAt
}: BiddingHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Container isLeading={isLeading}>
      <Title>
        {!isParticipating && isClosed && t('Bidding is complete')}
        {!isParticipating && !isClosed && t('Put your own price')}

        {isParticipating && !isCounting && !isClosed && (
          <>
            {isLeading ? (
              <>
                <LeaderIcon data-testid="crown-icon" />
                {t('You are winning')}
              </>
            ) : (
              <>
                <ErrorFilledIcon data-testid="overbid-icon" />
                {t('You are losing')}
              </>
            )}
          </>
        )}
      </Title>

      {!isClosed && (!isParticipating || (isParticipating && !isCounting)) && (
        <CaptionLink>
          <span>{!isCounting ? t('Closing time') : t('Remaining time')} </span>
          <span>
            {!isCounting &&
              dayjs(preliminaryCloseAt).isValid() &&
              `${dayjs(preliminaryCloseAt).format('D MMM HH:mm')} (${dayjs(
                preliminaryCloseAt
              ).fromNow()})`}
          </span>
          <span>{isCounting && t('Active')}</span>
        </CaptionLink>
      )}
    </Container>
  );
};

export default BiddingHeader;
